import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { AuthPage } from './pages/AuthPage';
import { GamePage } from './pages/GamePage';
import { OAuthCallbackPage } from './pages/OAuthCallbackPage';

const AppRoutes: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div>
          <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            🗺️ 全球涂鸦占领游戏
          </div>
          <div>加载中...</div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/auth"
        element={user ? <Navigate to="/game" replace /> : <AuthPage />}
      />
      <Route
        path="/auth/:provider/callback"
        element={<OAuthCallbackPage />}
      />
      <Route
        path="/game"
        element={user ? <GamePage /> : <Navigate to="/auth" replace />}
      />
      <Route
        path="/"
        element={<Navigate to={user ? "/game" : "/auth"} replace />}
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

export default App;